import { useEffect, useRef } from "react";
import { useOldBrowserDetection } from "@/shared/hooks/useOldBrowserDetection";

export const OldBrowserAlert = () => {
  const { isOldBrowser } = useOldBrowserDetection();
  const alertRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOldBrowser) {
      return;
    }

    const updateAlertOffset = () => {
      if (alertRef.current) {
        const alertHeight = alertRef.current.offsetHeight;
        document.documentElement.style.setProperty("--alert-offset", `${alertHeight}px`);
        document.body.classList.add("has-alert");
      }
    };

    updateAlertOffset();

    const resizeObserver = new ResizeObserver(updateAlertOffset);
    if (alertRef.current) {
      resizeObserver.observe(alertRef.current);
    }

    return () => {
      document.documentElement.style.removeProperty("--alert-offset");
      resizeObserver.disconnect();
    };
  }, [isOldBrowser]);

  if (!isOldBrowser) {
    return null;
  }

  return (
    <div
      ref={alertRef}
      className="old-browser-alert fixed inset-x-0 !top-0 left-0 right-0 z-[999999] flex justify-center items-center gap-5 px-2 py-1 bg-gradient-to-r from-red-600 to-orange-600 shadow-lg !pointer-events-auto"
    >
      <p className="text-white text-bold text-pretty text-shadow-xs text-sm md:text-base opacity-90">
        Votre navigateur est obsolète et certaines fonctionnalités peuvent ne pas fonctionner correctement.
      </p>
      <a
        href="https://browsehappy.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex-shrink-0 text-black px-4 py-1 rounded-full font-semibold bg-white shadow-lg transform transition animate-heartbeat hover:scale-105 hover:shadow-xl"
      >
        Veuillez le mettre à jour
      </a>
    </div>
  );
};
